import { Typography } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Page } from 'osep-react-antd';
import packageJson from '../../package.json';
import ConnectPrompt from '../components/connections/ConnectPrompt';

const ConnectToGitLabPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Page
      title="Connect to GitLab"
      onBack={() => navigate(-1)}
      footer={<Typography.Text disabled>{packageJson.version}</Typography.Text>}
    >
      <ConnectPrompt
        provider="gitlab"
        reason="To create a project, you need to connect the OSEP Generator with your GitLab account."
      />
    </Page>
  );
};

export default ConnectToGitLabPage;
